module.exports = __webpack_public_path__ + "static/media/Anivia.d5776a51.png";